import { Stack, useTheme, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { WhiteBox } from "@foodpilot/foods";
import { useParams } from "react-router";
import { useSsoDance } from "src/utils/useSsoDance.ts";

export const Saml2Login = () => {
    const { getAuth } = useSsoDance();
    const { providerName } = useParams<{ providerName: string }>();

    if (!providerName) {
        return <></>;
    }

    return (
        <WhiteBox padding="40px" paddingTop="32px" boxShadow="0 2px 8px 0 rgba(42, 43, 39, 0.04)" position="relative">
            <Stack>
                <LoginHeader />
                <Button onClick={() => getAuth("api/saml2/login/", providerName)}>Login with SAML 2.0</Button>
            </Stack>
        </WhiteBox>
    );
};

const LoginHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack justifyContent="center" alignItems="center" gap="16px">
            <Typography variant="h2" align="center">
                {t("login_title")}
            </Typography>
            <Typography variant="body" align="center" sx={{ color: theme.custom.grey[2000] }}>
                {t("login_info")}
            </Typography>
        </Stack>
    );
};
